import type { IngestionEventSeverity } from '@/shared/hooks/api/ingestionDiagnostics'

const TIMEZONE_LABEL =
  Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'local'

export function getDiagnosticsTimezoneLabel() {
  return TIMEZONE_LABEL
}

export function formatDiagnosticsDayHeader(iso: string) {
  return new Intl.DateTimeFormat(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(new Date(iso))
}

export function formatDiagnosticsTimeOnly(iso: string) {
  const date = new Date(iso)
  const time = new Intl.DateTimeFormat(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(date)
  const ms = String(date.getMilliseconds()).padStart(3, '0')
  return `${time}.${ms}`
}

export function groupByDiagnosticsDay<T extends { at: string }>(items: T[]) {
  const groups: Array<{ day: string; items: T[] }> = []
  for (const item of items) {
    const day = formatDiagnosticsDayHeader(item.at)
    const last = groups[groups.length - 1]
    if (last?.day === day) {
      last.items.push(item)
    } else {
      groups.push({ day, items: [item] })
    }
  }
  return groups
}

export function severityDotClass(severity: IngestionEventSeverity) {
  if (severity === 'success') {
    return 'bg-[#00d4b4]'
  }
  if (severity === 'failure') {
    return 'bg-destructive'
  }
  if (severity === 'warning') {
    return 'bg-[#ffb800]'
  }
  return 'bg-[#acb2b8]'
}

export function statusBadgeVariant(status: string) {
  if (status === 'COMPLETED') {
    return 'default'
  }
  if (status === 'FAILED') {
    return 'destructive'
  }
  if (status === 'PROCESSING') {
    return 'secondary'
  }
  return 'outline'
}
